import { heightImg } from "assets/images";
import CustomButton from "components/form";
import React from "react";

const Question5 = ({brandHeading,setBrandHeading,addOrUpdateQuestion,buttonLoaders,errors}) => {
  return (
    <>
      <div className="form_field page_title">
        <label className="label">Screen Title</label>
        <input type="text" className="form-control input"
        
           value={brandHeading}
           onChange={(e) => setBrandHeading(e.target.value)} />
                {errors.brandHeading && (
          <span className="error">{errors.brandHeading}</span>
        )}
      </div>
      
      <div className="button_wrap ">
        <CustomButton ref={buttonLoaders} onClick={addOrUpdateQuestion}>Save</CustomButton>
      </div>
    </>
  );
};

export default Question5;
